<template>
  <div class="flex flex-between">
    <div class="nav-item" v-if="shortcuts.length != 0">
      <el-dropdown>
        <span class="dropdown-link">
          <svg-icon icon-class="shortcut" class="nav-item-icon"></svg-icon
          >快捷操作
          <i class="el-icon-caret-bottom"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(sc, i) in shortcuts" :key="i">
            <router-link :to="{ path: sc.path, query: sc.query }">{{
              sc.label
            }}</router-link>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="nav flex-grow">
      <div class="nav-item" v-for="(item, index) in items" :key="index">
        <router-link
          :to="{ path: item.path, query: item.query }"
          v-if="!item.children"
        >
          <el-badge is-dot class="dot-tip" v-if="item.dotTipDF">
            <span v-html="item.label" v-if="item.label"></span>
            <svg-icon
              :icon-class="item.icon"
              class="nav-item-icon"
              v-if="item.icon"
            ></svg-icon>
          </el-badge>
          <template v-else>
            <span v-html="item.label" v-if="item.label"></span>
            <svg-icon
              :icon-class="item.icon"
              class="nav-item-icon"
              v-if="item.icon"
            ></svg-icon>
          </template>
        </router-link>
        <el-dropdown v-else>
          <el-badge is-dot class="dot-tip" v-if="item.dotTipDF">
            <span class="dropdown-link">
              <span v-html="item.label" v-if="item.label"></span>
              <svg-icon
                :icon-class="item.icon"
                class="nav-item-icon"
                v-if="item.icon"
              ></svg-icon>
              <i class="el-icon-caret-bottom"></i>
            </span>
          </el-badge>
          <span class="dropdown-link" v-else>
            <span v-html="item.label" v-if="item.label"></span>
            <svg-icon
              :icon-class="item.icon"
              class="nav-item-icon"
              v-if="item.icon"
            ></svg-icon>
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(child, i) in item.children"
              :key="i"
              :divided="child.divided"
            >
              <router-link :to="{ path: child.path, query: child.query }">
                {{ child.label }}
              </router-link>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div
        class="nav-item"
        v-if="
          Permit.canActions('customerView') || Permit.canActions('supplierView')
        "
      >
        <el-dropdown @command="sendMessage">
          <span class="dropdown-link">
            <svg-icon icon-class="sendMessage" class="nav-item-icon"></svg-icon>
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              command="sup2CusMes"
              v-if="
                ['charge', 'af'].includes(Permit.edition()) &&
                Permit.canActions('customerView')
              "
            >
              {{ $t("menu.customers") }}
            </el-dropdown-item>
            <el-dropdown-item
              command="cus2SupMes"
              v-if="
                ['charge', 'bf'].includes(Permit.edition()) &&
                Permit.canActions('supplierView')
              "
            >
              {{ $t("menu.suppliers") }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div
        class="nav-item"
        v-if="Permit.currentUser() && Permit.currentUser().admin"
      >
        <router-link to="/set/perference/users">
          <span v-html="'设置'"></span>
        </router-link>
      </div>
      <div class="nav-item">
        <el-dropdown @command="help">
          <span class="dropdown-link">
            帮助
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="userManual">使用手册</el-dropdown-item>
            <el-dropdown-item command="contact">联系客服</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="nav-item">
        <el-dropdown @command="handleCommand">
          <span class="dropdown-link">
            <svg-icon icon-class="user" class="nav-item-icon"></svg-icon>
            {{
              Permit.currentUser().name
                ? Permit.currentUser().name.length > 3
                  ? Permit.currentUser().name.substring(0, 3) + ".."
                  : Permit.currentUser().name.substring(0, 3)
                : ""
            }}
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="profile">{{
              $t("menu.profile")
            }}</el-dropdown-item>
            <el-dropdown-item command="company">{{
              $t("menu.company")
            }}</el-dropdown-item>
            <el-dropdown-item command="logout">{{
              $t("menu.logout")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 发消息 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('action.sendMessage')"
      :close-on-click-modal="false"
      :visible.sync="sendMessageDF"
      width="40%"
    >
      <el-form
        ref="sendMessageObjForm"
        :model="sendMessageObj"
        label-width="70px"
      >
        <el-form-item
          v-if="sendMessageObj.type == 'sup2CusMes'"
          :label="$t('menu.customers')"
          :prop="'customerId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('menu.customers')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="sendMessageObj.customerId"
            filterable
            clearable
          >
            <el-option
              v-for="customer in customers"
              :key="customer.id"
              :label="customer.name + '(' + customer.phone + ')'"
              :value="customer.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="sendMessageObj.type == 'cus2SupMes'"
          :label="$t('menu.suppliers')"
          :prop="'supplierId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('menu.suppliers')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="sendMessageObj.supplierId"
            filterable
            clearable
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name + '(' + supplier.phone + ')'"
              :value="supplier.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :prop="'content'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.content')]),
              trigger: 'blur',
            },
          ]"
          :label="$t('text.content')"
        >
          <tinymce-editor
            ref="editor"
            v-model="sendMessageObj.content"
            :height="150"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="sendMessageSubmitDoing"
          size="small"
          @click="sendMessageSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="sendMessageDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { page } from "@/utils/mixins.js";
import TinymceEditor from "@/components/TinymceEditor";
import Vue from "vue";
import Cookies from "@/utils/cookies";
import Permit from "../../utils/permit";
import ls from "store2";
import Notice from "@/api/notice.js";
import Customer from "@/api/customer.js";
import Supplier from "@/api/supplier.js";

export default {
  mixins: [page],
  props: {
    items: Array,
    shortcuts: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    TinymceEditor,
  },
  data() {
    return {
      Permit: Permit,
      //
      sendMessageDF: false,
      customers: [],
      customersLoading: false,
      suppliers: [],
      suppliersLoading: false,
      sendMessageObj: {
        content: null,
        customerId: null,
        supplierId: null,
        type: null,
      },
      sendMessageSubmitDoing: false,
    };
  },
  created() {
    this.items.forEach((item) => {
      if (item.numberFun) {
        this.computeNumber(item);
      }
    });
  },
  methods: {
    sendMessage(type) {
      const self = this;
      self.sendMessageObj.type = type;
      self.sendMessageObj.content = null;
      self.sendMessageObj.customerId = null;
      self.sendMessageObj.supplierId = null;
      if (type == "sup2CusMes") {
        self.getCustmers();
      } else {
        self.getSuppliers();
      }
      self.sendMessageSubmitDoing = false;
      self.sendMessageDF = true;
    },
    getCustmers() {
      const self = this;
      Customer.findWholesale().then(function (res) {
        if (res.status == 200) {
          self.customers = res.data.filter((r) => r.sourceTenantId != null);
        } else {
          self.sysResult();
        }
      });
    },
    getSuppliers() {
      const self = this;
      Supplier.findByTenantId().then(function (res) {
        if (res.status == 200) {
          self.suppliers = res.data.filter((r) => r.sourceTenantId != null);
        } else {
          self.sysResult();
        }
      });
    },
    sendMessageSubmit() {
      const self = this;
      self.$refs.sendMessageObjForm.validate((valid) => {
        if (valid) {
          self.sendMessageSubmitDoing = true;
          Notice.send(self.sendMessageObj).then(function (res) {
            if (res.status == 200) {
              self.sysResult(res.data);
              // self.$message({
              //   message: self.$t("prompt.sendSuccess"),
              //   type: "success",
              // });
              self.sendMessageSubmitDoing = false;
              self.sendMessageDF = false;
              self.loadData();
            } else {
              slef.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    async computeNumber(item) {
      const self = this;
      if (item.numberFun) {
        let res = await item.numberFun();
        let dotTipDF = res.data > 0 ? true : false;
        Vue.set(item, "dotTipDF", dotTipDF);

        // 广播接收
        for (const emitName of item.emitNames) {
          if (emitName == "emitDownLoad") {
            self.$eventHub.$on(emitName, async () => {
              Vue.set(item, "dotTipDF", true);
            });
          }
          if (
            emitName == "downloadFileDownloadFinish" ||
            emitName == "noticeReadFinish"
          ) {
            self.$eventHub.$on(emitName, async () => {
              Vue.set(item, "dotTipDF", false);
            });
          }
        }
      }
    },
    help(command) {
      if (command == "userManual") {
        this.$router.push("/normal/profile");
        window.open(
          "http://files.jianyingkeji.com/public/%E7%AE%80%E8%B5%A2%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C.pdf",
          "_blank"
        );
        return;
      }
      if (command == "contact") {
        this.$router.push("/normal/contact");
        return;
      }
    },
    handleCommand(command) {
      if (command == "logout") {
        Cookies.removeToken();
        ls.clearAll();
        window.location.reload();
        Store.remove("menuFix");
        Store.remove("openedMenus");
        return;
      }
      if (command == "profile") {
        this.$router.push("/normal/profile");
        return;
      }
      if (command == "company") {
        this.$router.push("/normal/company");
        return;
      }
    },
  },
};
</script>

<style scoped>
.nav {
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
}
.nav-item {
  height: 50px;
  line-height: 50px;
  padding: 0 10px;
  font-size: 12px;
}
.nav-item a {
  color: #696969;
  text-decoration: none;
}
.nav-item-icon {
  font-size: 14px;
}
.dot-tip {
  display: inline;
}
.dropdown-link {
  font-size: 12px;
}
.mgr10 {
  margin-right: 10px;
}
</style>